import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {INewTask, NewTask} from '../Tasks.ts';
import {TasksApi} from '../../../apis/TasksApi/TasksApi.ts';
import {useLowFrequencyRefreshQuery} from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';

export function useGetNewTask() {

    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.newTask],
        queryFn: async () => {
            const result: INewTask = await TasksApi.getNewTask();
            return new NewTask(result);
        },
    });
}